var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsCheckmark = function SvgDlsCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47.99 47.99"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.27 42.82L1.76 21.99l4.48-3.98 13.49 15.17L41.55 2.27l4.9 3.46z"
  })));
};

export default __webpack_public_path__ + "static/media/DLS_Checkmark.9da30610.svg";
export { SvgDlsCheckmark as ReactComponent };